<template>
  <div
    ref="pwaAlertIos"
    class="fixed inset-0 items-end justify-center hidden z-max"
    v-if="platform === 'ios'"
    v-show="!userHideIosAlert"
  >
    <div
      @click="handleInstallPrompt({platform: 'ios', show: false})"
      class="absolute z-0 w-full h-full duration-200 opacity-0"
      :class="{'bg-black': theme === 'light', 'bg-concrete': theme === 'dark'}"
    ></div>
    <div class="absolute flex flex-col w-screen h-full gap-4 p-4 duration-200 translate-y-2 opacity-0 z-1 bg-concrete pt-[12px]">
      <div class="flex items-center justify-between w-full" v-if="installPrompt === true">
        <div class="flex items-center justify-center p-2 cursor-pointer" @click="installPrompt = false">
          <ph-caret-left
            :size="24"
            :style="{
              color: themeColorHEX
            }"
          />
        </div>
        <img :src="appLogo" class="rounded-lg bg-white max-w-[8rem] max-h-[8rem] min-w-[8rem] min-h-[8rem]" />
        <div class="flex items-center justify-center w-10 h-10 p-2"></div>
      </div>
      <div
        v-if="installPrompt === false"
        class="flex flex-col items-center gap-8 md:bg-white md:max-w-[30rem] md:mx-auto md:w-full md:rounded-lg xs:pt-0 px-4 pb-4 h-full max-h-[45rem] md:border md:border-platinum"
      >
        <img :src="appLogo" class="rounded-lg bg-white max-w-[8rem] max-h-[8rem] min-w-[8rem] min-h-[8rem]" />
        <t-heading tag="h1" class="font-semibold text-center" color="black">{{ $t('auth.authHomeTitle') }}</t-heading>
        <div class="flex flex-col items-center w-full max-w-sm gap-4">
          <t-button buttonClass="justify-between" color="branded" @click.native="installPrompt = true">
            <template v-slot:left-side>
              <ph-device-mobile :size="24" class="text-white" />
            </template>
            <t-text class="font-semibold">{{ $t('components.installPrompt.installApp') }}</t-text>
            <template v-slot:right-side>
              <div class="w-6"></div>
            </template>
          </t-button>
          <t-button buttonClass="justify-between" @click.native="handleInstallPrompt({platform: 'ios', show: false})">
            <template v-slot:left-side>
              <ph-globe-simple :size="24" class="text-black" />
            </template>
            <t-text class="font-semibold">{{ $t('components.installPrompt.useWeb') }}</t-text>
            <template v-slot:right-side>
              <div class="w-6"></div>
            </template>
          </t-button>
        </div>
      </div>
      <div
        v-else
        class="absolute w-[358px] p-4 flex bottom-2 duration-200 translate-y-2 flex-col gap-4 bg-white rounded-lg mb-4"
        style="left: calc(50% - 179px)"
      >
        <div
          class="absolute -bottom-4"
          style="left: calc(50% - 19px); border-left: 19px solid transparent; border-right: 19px solid transparent; rotate: 180deg"
          :style="{'border-bottom': theme === 'light' ? '18px solid #fff' : '18px solid #363636'}"
        ></div>
        <t-heading tag="h2" class="font-semibold" color="black">{{ $t('components.installPrompt.installApp') }}</t-heading>
        <div class="flex flex-col gap-1">
          <t-text color="black" class="block gap-2"
            >1. {{ $t('components.installPrompt.ios.justTap') }}
            <img class="inline w-5 h-5" src="@/assets/static/img/howtoinstall-icon__ios.png" />
            {{ $t('components.installPrompt.ios.buttonInBrowser') }}</t-text
          >
          <t-text color="black">2. {{ $t('components.installPrompt.ios.addToHomeScreen') }}</t-text>
          <t-text color="black">3. {{ $t('components.installPrompt.ios.appWillBeInstalled') }}</t-text>
        </div>
        <img v-if="$i18n.locale === 'uk_UA'" :src="require(`@/assets/static/img/howtoinstall-ua.gif`)" />
        <img v-else :src="require(`@/assets/static/img/howtoinstall.gif`)" />
      </div>
    </div>
  </div>
  <div
    v-else-if="platform === 'android'"
    ref="pwaAlertAndroid"
    class="fixed inset-x-0 top-0 items-center justify-center hidden z-max"
    :style="{
      height:
        viewport.height < viewport.width
          ? `calc(var(--1svh) * 100 - 3rem)`
          : viewport.width >= $screen.md
          ? `calc(100vh - 8.75rem)`
          : `calc(var(--1svh) * 100)`,
      paddingTop: viewport.height < viewport.width ? '1rem' : `calc(4rem + ${$helpers.safeZone('top')})`
    }"
    v-show="!userHideAndroidAlert"
  >
    <div
      @click="handleInstallPrompt({platform: 'android', show: false})"
      class="absolute z-0 w-full h-full duration-200 opacity-0"
      :class="{'bg-black': theme === 'light', 'bg-concrete': theme === 'dark'}"
    ></div>
    <div class="absolute flex flex-col w-screen h-full gap-4 p-4 duration-200 translate-y-2 opacity-0 z-1 bg-concrete">
      <div class="flex items-center justify-between w-full pt-[34px]" v-if="installPrompt === true">
        <div class="flex items-center justify-center p-2 cursor-pointer" @click="installPrompt = false">
          <ph-caret-left
            :size="24"
            :style="{
              color: themeColorHEX
            }"
          />
        </div>
        <img :src="appLogo" class="rounded-lg bg-white max-w-[8rem] max-h-[8rem] min-w-[8rem] min-h-[8rem]" />
        <div class="flex items-center justify-center w-10 h-10 p-2"></div>
      </div>
      <div
        v-if="installPrompt === false"
        class="flex flex-col items-center gap-8 md:bg-white md:max-w-[30rem] md:mx-auto md:w-full md:rounded-lg md:pt-[34px] xs:pt-0 px-4 pb-4 h-full max-h-[45rem] my-auto md:border md:border-platinum"
      >
        <img :src="appLogo" class="rounded-lg bg-white max-w-[8rem] max-h-[8rem] min-w-[8rem] min-h-[8rem]" />
        <t-heading tag="h1" class="font-semibold text-center" color="black">{{ $t('auth.authHomeTitle') }}</t-heading>
        <div class="flex flex-col items-center w-full max-w-sm gap-4">
          <t-button buttonClass="justify-between" color="branded" @click.native="installPrompt = true">
            <template v-slot:left-side>
              <ph-device-mobile :size="24" class="text-white" />
            </template>
            <t-text class="font-semibold">{{ $t('components.installPrompt.installApp') }}</t-text>
            <template v-slot:right-side>
              <div class="w-6"></div>
            </template>
          </t-button>
          <t-button buttonClass="justify-between" @click.native="handleInstallPrompt({platform: 'android', show: false})">
            <template v-slot:left-side>
              <ph-globe-simple :size="24" class="text-black" />
            </template>
            <t-text class="font-semibold">{{ $t('components.installPrompt.useWeb') }}</t-text>
            <template v-slot:right-side>
              <div class="w-6"></div>
            </template>
          </t-button>
        </div>
      </div>
      <div v-else class="self-center my-auto flex flex-col w-[344px] rounded-lg gap-4 p-4 bg-white z-1">
        <div class="flex justify-between p-2">
          <div class="flex items-center w-full gap-4">
            <t-heading tag="h3" class="font-semibold line-clamp-2" color="black"
              >{{ $t('components.installPrompt.android.install') }} {{ appName }}</t-heading
            >
          </div>
        </div>
        <t-text color="black">{{ $t('components.installPrompt.android.description') }}</t-text>
        <div
          class="flex flex-wrap items-center gap-1"
          :class="{'py-2 px-4 justify-center bg-concrete rounded-md': userPrompt === null}"
        >
          <span class="text-black">{{ $t('components.installPrompt.android.press') }}</span>
          <ph-dots-three-vertical :size="24" :color="'#5a92f9'" />
          <span class="text-black">{{ $t('components.installPrompt.android.andSelect') }}</span>
          <svg style="color: #5a92f9" class="w-4 h-4">
            <use href="@/assets/static/img/icon__android-homescreen.svg#icon"></use>
          </svg>
          <font class="text-black">{{ $t('components.installPrompt.installApp') }}</font>
          <span v-if="userPrompt !== null" class="text-black">{{ $t('components.installPrompt.android.orSimply') }}</span>
          <span v-if="userPrompt !== null" class="text-black">{{ $t('components.installPrompt.android.description2') }}</span>
        </div>
        <div v-if="userPrompt !== null" class="flex gap-4">
          <t-button @click.native="handleInstallPrompt({platform: 'android', show: false})">
            <t-text>{{ $t('components.installPrompt.android.notNow') }}</t-text>
          </t-button>
          <t-button
            ref="btn"
            @click.native="
              handleInstallPrompt({platform: 'android', show: false})
              userPrompt.prompt()
              setUserPrompt(null)
            "
            color="branded"
          >
            <t-text>{{ $t('components.installPrompt.android.install') }}</t-text>
          </t-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {mapMutations} from 'vuex'
  import handleViewport from '@/utils/mixins/handleViewport'
  export default {
    name: 'installation-prompt',
    computed: {
      ...mapGetters(['appLogo', 'appName', 'appPublished', 'prefetchDone', 'theme', 'themeColorHEX']),
      ...mapGetters('user', ['userPrompt', 'userHideIosAlert', 'userHideAndroidAlert', 'showIosAlert', 'showAndroidAlert'])
    },
    props: {
      platform: {
        type: String,
        default: 'ios'
      }
    },
    mixins: [handleViewport],
    data() {
      return {
        installPrompt: false
      }
    },
    methods: {
      ...mapMutations('user', [
        'setUserPrompt',
        'setHideIosAlert',
        'setHideAndroidAlert',
        'deleteHideIosAlert',
        'deleteHideAndroidAlert',
        'handleInstallPrompt'
      ]),
      openPwaAlertAndroid() {
        this.deleteHideAndroidAlert()
        setTimeout(() => {
          this.$refs.pwaAlertAndroid.classList.replace('hidden', 'flex')
          setTimeout(() => {
            this.$refs.pwaAlertAndroid.firstChild.classList.replace('opacity-0', 'opacity-50')
            setTimeout(() => {
              this.$refs.pwaAlertAndroid.lastChild.classList.replace('opacity-0', 'opacity-100')
              this.$refs.pwaAlertAndroid.lastChild.classList.replace('translate-y-2', 'translate-y-0')
            }, 50)
          }, 0)
        }, 0)
      },
      closePwaAlertAndroid() {
        this.setHideAndroidAlert()
        this.$refs.pwaAlertAndroid.lastChild.classList.replace('opacity-100', 'opacity-0')
        this.$refs.pwaAlertAndroid.lastChild.classList.replace('translate-y-0', 'translate-y-2')
        setTimeout(() => {
          this.$refs.pwaAlertAndroid.firstChild.classList.replace('opacity-50', 'opacity-0')
        }, 50)
        setTimeout(() => {
          this.$refs.pwaAlertAndroid.classList.replace('flex', 'hidden')
          this.$forceUpdate()
        }, 250)
      },
      openPwaAlertIos() {
        this.deleteHideIosAlert()
        setTimeout(() => {
          this.$refs.pwaAlertIos.classList.replace('hidden', 'flex')
          setTimeout(() => {
            this.$refs.pwaAlertIos.firstChild.classList.replace('opacity-0', 'opacity-50')
            setTimeout(() => {
              this.$refs.pwaAlertIos.lastChild.classList.replace('opacity-0', 'opacity-100')
              this.$refs.pwaAlertIos.lastChild.classList.replace('translate-y-2', 'translate-y-0')
            }, 50)
          }, 0)
        }, 0)
      },
      closePwaAlertIos() {
        this.setHideIosAlert()
        this.$refs.pwaAlertIos.lastChild.classList.replace('opacity-100', 'opacity-0')
        this.$refs.pwaAlertIos.lastChild.classList.replace('translate-y-0', 'translate-y-2')
        setTimeout(() => {
          this.$refs.pwaAlertIos.firstChild.classList.replace('opacity-50', 'opacity-0')
        }, 50)
        setTimeout(() => {
          this.$refs.pwaAlertIos.classList.replace('flex', 'hidden')
          this.$forceUpdate()
        }, 250)
      }
    },
    async created() {
      await this.prefetchDone
      if (this.$helpers.getDeviceType() !== 'phone' || this.$cookies.get('install_declined')) return
      if (this.appPublished) {
        if (!this.$helpers.isPreviewFrame() && !this.$helpers.isPwaOpened()) {
          if (this.$helpers.getBrowserName() === 'safari' && !this.userHideIosAlert) {
            this.handleInstallPrompt({platform: 'ios', show: true})
          } else if (this.$helpers.getBrowserName() !== 'safari' && !this.userHideAndroidAlert) {
            window.addEventListener('beforeinstallprompt', async e => {
              // Prevents the default mini-infobar or install dialog from appearing on mobile
              e.preventDefault()
              // Save the event because you'll need to trigger it later.
              this.setUserPrompt(e)
              this.handleInstallPrompt({platform: 'android', show: true})
            })
          }
        }
      }
    },
    watch: {
      showAndroidAlert(show) {
        if (show) this.openPwaAlertAndroid()
        else this.closePwaAlertAndroid()
      },
      showIosAlert(show) {
        if (show) this.openPwaAlertIos()
        else this.closePwaAlertIos()
      }
    }
  }
</script>
